import {
  ADMIN_CREATE_TENANT,
  ADMIN_SETUP_TENANT_BILLING,
  RESUME_ONBOARDING,
  GET_ONBOARDING_STATUS,
  LIST_ONBOARDINGS,
  GET_ONBOARDING_CONFIG,
  UPDATE_ONBOARDING_CONFIG,
} from '../lib/constant';

const initialState = {
  createResult: null,
  setupBillingResult: null,
  resumeResult: null,
  onboardingStatus: null,
  onboardingList: null,
  onboardingConfig: null,
  updateConfigResult: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADMIN_CREATE_TENANT:
      return { ...state, createResult: action.payload };
    case ADMIN_SETUP_TENANT_BILLING:
      return { ...state, setupBillingResult: action.payload };
    case RESUME_ONBOARDING:
      return { ...state, resumeResult: action.payload };
    case GET_ONBOARDING_STATUS:
      return { ...state, onboardingStatus: action.payload };
    case LIST_ONBOARDINGS:
      return { ...state, onboardingList: action.payload };
    case GET_ONBOARDING_CONFIG:
      return { ...state, onboardingConfig: action.payload };
    case UPDATE_ONBOARDING_CONFIG:
      return { ...state, updateConfigResult: action.payload };
    default:
      return state;
  }
}
